import React from 'react'

// Chakra Components
import {
    AspectRatio,
    Box,
    Stack,
    HStack,

    // Hooks
    Skeleton as ChakraSkeleton,
    useMultiStyleConfig
} from '@chakra-ui/react'

/**
 * The skeleton representation of the emotional gallery component. Use this component while
 * you are waiting for product data to be returned from the server.
 */
const EmotionalGallerySkeleton = () => {
    const styles = useMultiStyleConfig('EmotionalGallery')

    return (
        <Box data-testid="sf-emotional-gallery-skeleton">
            <AspectRatio ratio={2 / 1}>
                <ChakraSkeleton />
            </AspectRatio>

            <HStack {...styles.controls}>
                {[1, 2, 3, 4, 5].map((_, index) => {
                    return (
                        <Stack spacing={1} key={index}>
                            <ChakraSkeleton width={6} height={1.5} />
                        </Stack>
                    )
                })}
            </HStack>
        </Box>
    )
}

export default EmotionalGallerySkeleton
